import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b1b1c56&scoped=true&lang=html&"
import script from "./distributorMall.js?vue&type=script&lang=js&"
export * from "./distributorMall.js?vue&type=script&lang=js&"
import style0 from "./distributorMall.styl?vue&type=style&index=0&id=5b1b1c56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b1c56",
  null
  
)

export default component.exports